import React, { Component } from 'react';
import iconShare from '../../images/icons/icon_sharelink.png';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

class CopyButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
    };
    this.textAreaRef = React.createRef();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    let tempInput = document.createElement('input');
    let urlStr = window.location.href;
    document.body.appendChild(tempInput);
    tempInput.value = urlStr;
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    this.setState({
      clicked: true,
    });
  }

  render() {
    const { clicked } = this.state;
    const { t } = this.props;

    return (
      <button
        onClick={this.handleClick}
        className={`fe-share-btn copy ${clicked ? 'clicked' : ''}`}
      >
        <img src={iconShare} alt=""/>
        <span>{t('gen:copied')}</span>
      </button>
    );   
  }
}

CopyButton.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CopyButton);